import { c as a } from "./index807.mjs";
import { f as n } from "./index743.mjs";
var o = a, s = n, u = function(r) {
  if (o(r) === "Function")
    return s(r);
};
export {
  u as f
};
